import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FindingBriefBullets } from './FindingBriefBullets';
import {
  findingBriefSectionLabelSx,
  findingBriefSectionSx,
  type FindingBriefSectionVariant,
} from './findingBriefSectionStyles';

/** Scannable evidence block — case summary, reviewer action, or follow-up. */
export function FindingBriefSection({
  variant,
  accent,
  label,
  lead,
  points,
}: {
  variant: FindingBriefSectionVariant;
  accent: string;
  label?: string;
  lead?: string;
  points?: string[];
}) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const hasPoints = Boolean(points?.length);
  const leadText = lead?.trim() ?? '';

  if (!leadText && !hasPoints) return null;

  const bulletAccent =
    variant === 'followup' ? (isLight ? '#047857' : '#34d399') : accent;

  return (
    <Box sx={findingBriefSectionSx(variant, accent, isLight)}>
      {label ? (
        <Typography variant="caption" sx={findingBriefSectionLabelSx(variant, accent, isLight)}>
          {label}
        </Typography>
      ) : null}
      {leadText ? (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            lineHeight: 1.5,
            fontSize: '0.8125rem',
            color: 'text.secondary',
            mb: hasPoints ? 0.55 : 0,
          }}
        >
          {leadText}
        </Typography>
      ) : null}
      {hasPoints ? <FindingBriefBullets items={points!} accent={bulletAccent} /> : null}
    </Box>
  );
}
